import { createGetEndpoint } from '@sonar-software/sonar-http';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

export type GetObjectNamesByTypeRequest = {
	type: SonarObjectType;
};

export type GetObjectNamesByTypeResponse = Array<string>;

export const getObjectNamesByType = createGetEndpoint<GetObjectNamesByTypeRequest, GetObjectNamesByTypeResponse>(
	({ type }) => `/api/v3/data-dictionary/sonar-object/types/${type}/object-names`
);
